module.exports = __webpack_public_path__ + "static/media/Graphik-Medium.e2fd4fd7.woff";